import { render } from "./AppointmentSummary.vue?vue&type=template&id=95161690"
import script from "./AppointmentSummary.vue?vue&type=script&lang=js"
export * from "./AppointmentSummary.vue?vue&type=script&lang=js"

import "./AppointmentSummary.vue?vue&type=style&index=0&id=95161690&lang=css"
script.render = render

export default script